<!-- <p>additional-information-preview works!</p> -->
<div *ngIf="previewData">
  <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
  <div>
    <strong>Special Requirements:&nbsp;</strong> <span class="fw-semibold">{{previewData.specialRequirements}} </span>
  </div>
  <div>
    <strong>Final Comments:&nbsp;</strong> <span class="fw-semibold">{{previewData.finalComments}}</span>
  </div>
 
</div>
